var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepperCheckedHos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14C0.5 15.8385 0.862121 17.659 1.56569 19.3576C2.26925 21.0561 3.30048 22.5995 4.6005 23.8995C5.90053 25.1995 7.44387 26.2307 9.14243 26.9343C10.841 27.6379 12.6615 28 14.5 28C16.3385 28 18.159 27.6379 19.8576 26.9343C21.5561 26.2307 23.0995 25.1995 24.3995 23.8995C25.6995 22.5995 26.7307 21.0561 27.4343 19.3576C28.1379 17.659 28.5 15.8385 28.5 14C28.5 10.287 27.025 6.72601 24.3995 4.10051C21.774 1.475 18.213 0 14.5 0C10.787 0 7.22601 1.475 4.6005 4.10051C1.975 6.72601 0.5 10.287 0.5 14Z",
    fill: "#132227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14L12.5 18L20.5 10",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperCheckedHos);
export default __webpack_public_path__ + "static/media/stepper-checked-hos.96b4b81db76fe51e08e1317a3b646c21.svg";
export { ForwardRef as ReactComponent };